import _ from 'lodash';
import { convertJson2Xml } from '@/components/Helper';
import EventBus from '@/EventBus';
import axios from 'axios';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import { forEachCanvasObject } from '@/components/Canvas/utils/groupHelpers';

export default {
  methods: {
    encodeObjectForSave(object) {
      if (object.type == 'text') {
        (object.fontSize == null) && (object.fontSize = object.valuesForLeftPanel.fontSize); // this line added trello card ---> https://trello.com/c/XQoKxsT1/716-null-value-for-font-size
        object.Value                       = encodeURIComponent(object.Value); // this.encodeHTML(object.Value)
        object.modifiedHtml                = object.Value;
        object.curvedHtml                  = object.curvedHtml ? encodeURIComponent(object.curvedHtml) : '';
        object.unCurvedHtml                = object.unCurvedHtml ? encodeURIComponent(object.unCurvedHtml) : '';
        object.fontSize                    = parseFloat(object.fontSize);
        object.valuesForLeftPanel.fontSize = parseFloat(object.valuesForLeftPanel.fontSize); // converting string to number for this card : https://trello.com/c/YQQPaR2V/670-user-error
      }

      if (object.type == 'image' && (object.ImageType == 'SVGImage' || object.ImageType.indexOf('FDIC') !== -1)) {
        object.Height              = (isNaN(object.Height)) ? 0 : Math.round(object.Height);
        object.Width               = (isNaN(object.Width)) ? 0 : Math.round(object.Width);
        object.SvgProperty.content = encodeURIComponent(object.SvgProperty.content);
      }
      if (object.type == 'image' && object.croppedSrc != 'none') {
        object.DefaultImageUrl    = encodeURIComponent(object.DefaultImageUrl);
        object.croppedSrc         = encodeURIComponent(object.croppedSrc);
        object.croppedHighResPath = encodeURIComponent(object.croppedHighResPath);
        object.HighResPath        = encodeURIComponent(object.HighResPath);
      }
      if (object.type == 'image' && object.AlternativeImageUrlsResVersion) {
        object.AlternativeImageUrlsResVersion.forEach((cur) => {
          if (cur.ImageThumbnailPath && cur.ImageThumbnailPathV2) {
            cur.ImageThumbnailPath   = encodeURIComponent(cur.ImageThumbnailPath);
            cur.ImageThumbnailPathV2 = encodeURIComponent(cur.ImageThumbnailPathV2);
          }
        });
      }

      if (object.type == 'shape' && object.SvgProperty && object.SvgProperty.content) {
        object.SvgProperty.content = encodeURIComponent(object.SvgProperty.content);
      }

      if (object.SortOrder == null || object.SortOrder == 'null') {
        object.SortOrder = 0;
      }

      if (object.SvgProperty && this.isHTML(object.SvgProperty.content)) {
        object.SvgProperty.content = encodeURIComponent(object.SvgProperty.content);
      }
    },
    encodeProductObjectsForSave(product) {
      product.pages.forEach((page) => {
        forEachCanvasObject(page.objectList, (object) => {
          this.encodeObjectForSave(object);
        });
      });
    },

    saveProductAsTemplate(pdfURL) {
      this.product.pdfUrl = pdfURL;
      let product         = JSON.parse(JSON.stringify(this.product));
      this.encodeProductObjectsForSave(product);
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const bankId             = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;

      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=NewEditorSaveAsTemplate&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&productId=${product.Id}`;

      const postData = new FormData();
      delete product.pdfURL;
      product = { ...product, ...{ thumbnailURL: pdfURL } };
      postData.append('jsonInfo', JSON.stringify(product));

      const headers = { 'Content-Type': 'text/plain' };

      axios.post(url, postData, { headers }).then((result) => {
        EventBus.$emit('showHideLoader', false);
        this.saveProductResponse(result.data);
      }).catch((error) => {
        EventBus.$emit('showHideLoader', false);
        this.$store.getters.getIsSavedAndClosed && this.$store.commit('setIsSavedAndClosed', false);
        console.error(error);
      });
    },

    onSaveProduct(pdfURL) {
      this.product.isEditedByNewEditor = true;
      this.product.pdfUrl              = pdfURL;
      // ToDO:we use only one format to save product
      const product = JSON.parse(JSON.stringify(this.product)); //  deep copy for XML;

      setTimeout(() => {
        this.saveJsonFormatProduct(product, pdfURL);
      }, 0);
    },
    getProductXml(product) {
      const productWidth  = { double: [] };
      const productHeight = { double: [] };
      const fields        = { TextField: [] };
      const backgrounds   = { BackgroundField: [] };
      const images        = { ImageField: [] };
      for (let pageIndex = 0; pageIndex < product.pages.length; pageIndex++) {
        productWidth.double.push(product.pages[pageIndex].width);
        productHeight.double.push(product.pages[pageIndex].height);

        product.pages[pageIndex].objectList.forEach((item) => {
          item.PageNo += 1;
          switch (item.type) {
            case 'text': {
              fields.TextField.push(item);
              break;
            }
            case 'shape': {
              backgrounds.BackgroundField.push(item);
              break;
            }
            case 'image': {
              images.ImageField.push(item);
            }
          }
        });
      }
      product.PageWidths  = productWidth;
      product.PageHeights = productHeight;
      product.Backgrounds = backgrounds;
      product.Fields      = fields;
      product.Images      = images;

      delete product.pages;

      const productXML = convertJson2Xml({ ...product });
      return productXML;
    },
    saveXmlFormatProduct(product) {
      const xmlTag = '<?xml version="1.0" encoding="utf-16"?> <ProductInfo xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">';
      const xml    = `<![CDATA[${xmlTag}${this.getProductXml(product)}</ProductInfo>]]>`;
    },
    saveJsonFormatProduct(product, pdfURL) {
      // / product.BaseImage = encodeURIComponent(product.BaseImage)
      product.Name = encodeURIComponent(product.Name);
      this.encodeProductObjectsForSave(product);

      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const bankId             = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';

      const orderItemId = (this.$store.getters.getOrderItemId.includes('"')) ? this.$store.getters.getOrderItemId.slice(1, -1) : this.$store.getters.getOrderItemId;
      const method      = this.$store.getters.getSaveApiMethod ? this.$store.getters.getSaveApiMethod : 'NewEditorSave';
      const domainUrl   = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      let submittedAs   = '';
      if (method === 'NewEditorSubmit') {
        submittedAs = (this.$store.getters.getSubmittedAs === 'video') ? '&submittedAs=video' : '&submittedAs=image';
      }
      const url = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=${method}&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&productId=${product.Id}&orderItemId=${orderItemId}${submittedAs}`;

      const postData = new FormData();
      if (this.$store.getters.getPreviewClicked == 'image') {
        delete product.pdfUrl;
        delete product.pdfURL;
        product = { ...product, ...{ pdfUrl: pdfURL } }; // As client requirement we added pdfUrl in jsonInfo
      } else if ((product.videoUrl == undefined || product.videoUrl == '')) {
        product.videoUrl = 'videonotcreatedyet';
      }
      product = { ...product, ...{ submittedAs: this.$store.getters.getSubmittedAs } };
      // product.pdfUrl = encodeURIComponent(product.pdfUrl)
      postData.append('jsonInfo', JSON.stringify(product));
      // postData.append('pdfUrl', pdfURL);


      const headers = { 'Content-Type': 'text/plain' };

      axios.post(url, postData, { headers }).then((result) => {
        EventBus.$emit('showHideLoader', false);
        this.saveProductResponse(result.data);
      }).catch((error) => {
        EventBus.$emit('showHideLoader', false);
        this.$store.getters.getIsSavedAndClosed && this.$store.commit('setIsSavedAndClosed', false);
        console.error(error);
      });
    },
    isHTML(str) {
      const a     = document.createElement('div');
      a.innerHTML = str;
      for (let c = a.childNodes, i = c.length; i--;) {
        if (c[i].nodeType == 1) { return true; }
      }
      return false;
    },
    saveProductResponse(result) {
      const domParser     = new DOMParser();
      const parsedResult  = domParser.parseFromString(result, 'text/xml'); // NewEditorSaveAs
      const resultTagName = `${this.$store.getters.getSaveApiMethod}Result`;
      //= = 'NewEditorSubmit' ? 'NewEditorSubmitResult' : 'NewEditorSaveResult';
      const newEditorSaveResult = parsedResult.getElementsByTagName(resultTagName);

      let orderId = newEditorSaveResult[0].innerHTML;
      // TODO: don't remove this code the orderId contain multiple double quotes at start & end

      if (orderId.includes('ERROR')) {
        EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
          request: 'SaveOrderReject',
          message: `Success: Your ${this.$store.getters.getSaveApiMethod === 'NewEditorSaveAsTemplate' ? 'template' : 'order'} Has Been Saved.`,
        });
      } else {
        let location = null;
        if (orderId && orderId.includes('"')) {
          orderId   = `${orderId}`;
          let alter = 0;
          while (orderId.includes('"')) {
            orderId = orderId.slice(1, -1);
            alter++;
            if (alter > 5) {
              break;
            }
          }
        }
        if (orderId && this.$store.getters.getSaveApiMethod === 'NewEditorSubmit') {
          location = '//2';
          this.$store.getters.getBMCInstance === 'marketingcenter.source4' && (location = `//${this.$store.getters.getBMCInstance}.com/r/Editor/WysiwygSubmit/${orderId}`);
          this.$store.getters.getRedirectUrl && (location = `${this.$store.getters.getRedirectUrl}/${orderId}`);
          // const location = document.URL.startsWith('https://www.cumarketingcenter.com') || document.URL.startsWith('http://www.cumarketingcenter.com') || document.URL.includes('www.cumarketingcenter.com') ||  document.URL.startsWith('https://dev2.wysiwyg.cumarketingcenter.com')||  document.URL.startsWith('http://dev2.wysiwyg.cumarketingcenter.com') ?`//www.cumarketingcenter.com/r/Orders/SubmitForm/${orderId}`: `//www.bankmarketingcenter.com/r/Orders/SubmitForm/${orderId}`;
          // window.location.ancestorOrigins.length && (top.window.location.href = location)//when editor is loaded inside iFrame we would change the top address
          // !window.location.ancestorOrigins.length && (window.location.href = location)
          window.top.location = location;
          return;
        }
        if (orderId && this.$store.getters.getIsSavedAndClosed) {
          const bmcInstance = this.$store.getters.getBMCInstance;
          location          = `//www.${bmcInstance}.com/r/Editor/WysiwygSubmit/${orderId}`;
          switch (bmcInstance) {
            case 'bankmarketingcenter':
              location = `//www.${bmcInstance}.com/r/Archives?orderStatusFilter=progress`;
              break;
            case 'marketingcenter.source4':
              location = `//${bmcInstance}.com/r/Archives?orderStatusFilter=progress`;
              break;
          }
        } else if (orderId && (this.$store.getters.getSaveApiMethod === 'NewEditorSaveAs' || this.$store.getters.getSaveApiMethod === 'NewEditorSave')) {
          const bmcInstance = this.$store.getters.getBMCInstance;
          location          = `//www.${bmcInstance}.com/r/Editor/EditWysiwygNewEditor/${orderId}`;
        } else if (orderId && this.$store.getters.getSaveApiMethod === 'NewEditorSaveAsTemplate') {
          // https://www.bankmarketingcenter.com/r/Editor/WysiwygNewEditor/91418b50-3bf0-4af5-a57f-4d195d3432d1
          const bmcInstance = this.$store.getters.getBMCInstance;
          location          = `//www.${bmcInstance}.com/r/Editor/WysiwygNewEditor/${orderId}`;
        }


        orderId && (this.$store.commit('updateOrderItemId', orderId)); // TODO:update order item id when we have new order create
        orderId && (EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
          request: 'SaveReqWithRedirect',
          message: `Success: Your ${this.$store.getters.getSaveApiMethod === 'NewEditorSaveAsTemplate' ? 'template' : 'order'} Has Been Saved.`,
          data:    { location },
        }));
      }
      this.$store.commit('setSaveApiMethod', ''); // again setting the default value in the store
    },

  },
};
